module.exports = __webpack_public_path__ + "static/media/amadeus.e2afa33a.png";